import { IconSelectTick, SandTimerIcon } from '@/assets/images';
import {
   MESSAGE_DELIVERED_STATUS_ID,
   MESSAGE_PROCESSING_STATUS_ID,
   MESSAGE_SEEN_STATUS_ID,
   MESSAGE_SENT_STATUS_ID,
} from '@/shared/constants';
import PropTypes from 'prop-types';
import { memo } from 'react';
import './MessageStatus.scss';

const STATUS_CLASS_MAP = {
   [MESSAGE_SEEN_STATUS_ID]: 'read',
   [MESSAGE_DELIVERED_STATUS_ID]: 'delivered',
   [MESSAGE_SENT_STATUS_ID]: 'sent',
};

const MessageStatus = memo(({ msgStatus, className = '', style = {} }) => {
   if (msgStatus === MESSAGE_PROCESSING_STATUS_ID) {
      return (
         <i className={`message-status timer ct-flexCenter ${className}`.trim()} style={style}>
            <SandTimerIcon width={10} height={10} />
         </i>
      );
   }

   const statusClass = STATUS_CLASS_MAP[msgStatus] ?? '';
   if (!statusClass) return null;

   if (msgStatus === MESSAGE_SENT_STATUS_ID) {
      return (
         <span className={`message-status tick-container ${statusClass} ${className}`.trim()} style={style}>
            <IconSelectTick className="tick-icon single" />
         </span>
      );
   }

   if (msgStatus === MESSAGE_DELIVERED_STATUS_ID || msgStatus === MESSAGE_SEEN_STATUS_ID) {
      return (
         <span className={`message-status tick-container ${statusClass} ${className}`.trim()} style={style}>
            <IconSelectTick className="tick-icon first-tick" />
            <IconSelectTick className="tick-icon second-tick" />
         </span>
      );
   }

   return <span className={`message-status ${statusClass} ${className}`.trim()} style={style} />;
});

MessageStatus.propTypes = {
   msgStatus: PropTypes.number,
   className: PropTypes.string,
   style: PropTypes.object,
};

export default MessageStatus;
